import React, {Component, createRef} from 'react'
import {findDOMNode} from 'react-dom'
import propTypes from 'prop-types'
import {isNil} from 'lodash'
import {prefix} from 'helpers/component'
import DatePickerRange from 'components/datePickerRange'
import {SelectField} from 'components/selectField'
import {getDateSelectorLabelForKey} from 'helpers/dateRange'
import {formatLocaleDate, isSameDate} from 'helpers/dates'
import './datePickerRangeSelectField.scss'

export default class DatePickerRangeSelectField extends Component {

  constructor(props) {
    super(props)

    this.state = this.getDefaultState()
    this.getClass = prefix('datePickerRangeSelector-')
    this.selectRef = createRef()
  }

  getDefaultState = () => {
    return {
      datePickerAnchor: null,
      showingDatePicker: false,
    }
  }

  showDatePicker = () => {
    if (this.dontShowDatePicker) {
      this.dontShowDatePicker = false
      setTimeout(() => this.hiddenInput.focus(), 100)
    } else {
      this.setState({
        showingDatePicker: true,
        datePickerAnchor: findDOMNode(this.selectRef.current),
      })
    }
  }

  hideDatePicker = () => {
    this.setState({
      showingDatePicker: false,
    })
  }

  commitDatePicker = ({startDate, endDate, timeKey}) => {
    const {onChange} = this.props
    this.hideDatePicker()
    onChange(startDate, endDate, timeKey)
  }

  clearTarget = () => {
    const {onChange} = this.props
    onChange(null, null)
    this.dontShowDatePicker = true
  }

  getTargetValue = () => {
    const {startDate, endDate, timeKey, labelPrefix} = this.props

    if (!isNil(timeKey))
      return {
        value: 0,
        label: `${labelPrefix}${getDateSelectorLabelForKey(timeKey)}`,
      }

    return (!isNil(startDate) && !isNil(endDate))
      ? {
        value: 0,
        label: isSameDate(startDate, endDate - 1)
          ? `${labelPrefix}${this.formatDate(startDate)}`
          : `${labelPrefix}${this.formatDate(startDate)} - ${this.formatDate(endDate - 1)}`,
      }
      : null
  }

  formatDate = (date) => {
    const {locale, dateFormat} = this.props
    return formatLocaleDate(new Date(date), locale, dateFormat)
  }

  getHeight = () => {
    const {label} = this.props
    return isNil(label) ? 38 : 75
  }

  render() {
    const {
      anchorOrigin,
      className,
      clearable,
      disabled,
      flat,
      label,
      placeholder,
      presetTypes,
      showPresets,
      startDate,
      endDate,
      styles,
      targetOrigin,
      timeKey,
    } = this.props
    const {showingDatePicker, datePickerAnchor} = this.state

    return (
      <div
        className={`${this.getClass('container')} ${className}`}
        style={{height: this.getHeight()}}
      >
        <SelectField
          label={label}
          placeholder={placeholder}
          value={this.getTargetValue()}
          openMenuOnFocus={false}
          openMenuOnClick={false}
          disabled={disabled}
          clearable={clearable}
          ref={this.selectRef}
          flat={flat}
          styles={styles}
          onChange={this.clearTarget}
          onFocus={this.showDatePicker}
        />
        <DatePickerRange
          open={showingDatePicker}
          anchor={datePickerAnchor}
          startDate={startDate}
          endDate={endDate}
          timeKey={timeKey}
          showPresets={showPresets}
          presetTypes={presetTypes}
          anchorOrigin={anchorOrigin}
          targetOrigin={targetOrigin}
          onClose={this.hideDatePicker}
          onSubmit={this.commitDatePicker}
        />
        <input
          className={this.getClass('hidden-input')}
          ref={e => this.hiddenInput = e}
        />
      </div>
    )
  }
}


DatePickerRangeSelectField.propTypes = {
  anchorOrigin: propTypes.shape({
    horizontal: propTypes.string.isRequired,
    vertical: propTypes.string.isRequired,
  }),
  className: propTypes.string,
  clearable: propTypes.bool,
  dateFormat: propTypes.string,
  disabled: propTypes.bool,
  flat: propTypes.bool,
  label: propTypes.string,
  labelPrefix: propTypes.string,
  locale: propTypes.string,
  onChange: propTypes.func.isRequired,    // (startDate, endDate)
  placeholder: propTypes.string,
  presetTypes: propTypes.string,
  showPresets: propTypes.bool,
  startDate: propTypes.number,
  endDate: propTypes.number,
  styles: propTypes.object,
  targetOrigin: propTypes.shape({
    horizontal: propTypes.string.isRequired,
    vertical: propTypes.string.isRequired,
  }),
  timeKey: propTypes.string,
}

DatePickerRangeSelectField.defaultProps = {
  clearable: true,
  disabled: false,
  label: null,
  labelPrefix: '',
  placeholder: 'Any Time',
}
